import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

import { useToastAlertStore } from '@/store/toast-alert/toast-alert.state'
import ToastAlert from './ToastAlert.vue';
import { storeToRefs } from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastAlertContainer',
  setup(__props) {

const toastAlertStore = useToastAlertStore();
const { toastAlerts } = storeToRefs(toastAlertStore);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    name: "toast",
    tag: "div",
    class: "fixed bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 z-50 w-full"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toastAlerts), (toast) => {
        return (_openBlock(), _createBlock(ToastAlert, {
          key: toast.id,
          toastAlert: toast,
          onClose: _unref(toastAlertStore).initiateCloseToastAlert,
          class: "relative pointer-events-auto w-full px-4"
        }, null, 8, ["toastAlert", "onClose"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})